// src/services/adminAnalytics.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminAnalytics = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
  );

  const qs = new URLSearchParams(clean).toString();
  return adminApiRequest(`/admin/analytics${qs ? `?${qs}` : ""}`);
};
